import { SvgIcon, SvgIconProps, SxProps, Theme } from '@mui/material';
import { SvgIconComponent } from '@mui/icons-material';

export const createIconFromSvg = (iconComponent: React.ComponentType, viewBox = '0 0 24 24', sxProps?: SxProps<Theme>): SvgIconComponent => {
  const comp = (props: SvgIconProps): JSX.Element => {

    return (
      <SvgIcon
        {...props}
        component={iconComponent}
        viewBox={viewBox}
        sx={[
          ...(Array.isArray(sxProps) ? sxProps : [ sxProps ]),
          ...(Array.isArray(props.sx) ? props.sx : [ props.sx ]),
        ]}
      />
    );
  };

  comp.muiName = 'custom';

  return comp;
};
